/**
 * VH-125: a training template's difficulty is DERIVED from the exercises it
 * contains, never captured on the template itself.
 *
 * Lives in its own module rather than beside the page component: a component
 * file that also exports helpers breaks React fast refresh.
 */

/**
 * Render a template's derived difficulty as a range.
 *
 * The backend sends the easiest and hardest level found across the template's
 * exercises. Equal ends mean one shared level and render as a single label
 * rather than "Intermediate–Intermediate". Missing ends mean there are no
 * exercises to summarise — an explicit empty state, never an invented level.
 *
 * @param {object} template  template payload (may predate the derived fields)
 * @param {Function} t       i18next translate function
 * @returns {string}
 */
export function formatDifficultyRange(template, t) {
  const low = template?.derived_difficulty_min
  const high = template?.derived_difficulty_max
  if (!low || !high) return t('templates.noExercisesYet', 'No exercises yet')

  const label = (level) => t(`exercises.difficulty.${level}`)
  return low === high ? label(low) : `${label(low)}–${label(high)}`
}
